<template>
  <div>
    <NavBar />
    <div class="row pt-5 mx-0">
      <div class="col-md-12 b-grey">
        <div class="container py-4 h-auto px-sm-0" id="container">
          <div class="row">
            <div class="col-lg-3 col-md-4 col-sm-12">
              <img src="@/assets/img/mobil.png" alt="" class="w-100" />
            </div>
            <div class="col-lg-9 col-md-8 col-sm-12 py-3">
              <h1 class="fs-24 font-weight-bold">2019 ACURA LX</h1>
              <p class="mb-0">IDR</p>
              <p class="fs-24 font-weight-bold">190 Juta</p>
            </div>
          </div>
          <div class="list-data-preorder-mobile">
            <p class="fs-18 font-weight-bold">Jadwal Pelaksaan Preorder</p>
            <div class="row">
              <div class="border-right-mobile col-sm-6 col-6">
                <div class="list-preorder-mobile mg-bottom120 orange">
                  <p class="fs-16 text-white mb-0">Batas Preorder</p>
                  <p class="text-white">12 Feb 2018</p>
                  <div class="position-relative">
                    <div class="rounded-small-green-left"></div>
                  </div>
                </div>
                <div class="list-preorder-mobile mg-bottom80 green">
                  <p class="fs-16 text-white mb-0">Batas Pelunasan</p>
                  <p class="text-white">12 Feb 2018</p>
                  <div class="position-relative">
                    <div class="rounded-small-green-left"></div>
                  </div>
                </div>
              </div>
              <div class="border-left-mobile col-sm-6 col-6">
                <div class="list-preorder-mobile mg-top80 blue">
                  <p class="fs-16 text-white mb-0">Informasi Harga Final</p>
                  <p class="text-white">12 Feb 2018</p>
                  <div class="position-relative">
                    <div class="rounded-small-green-right"></div>
                  </div>
                </div>
                <div class="list-preorder-mobile mg-top120 pink">
                  <p class="fs-16 text-white mb-0">Mulai Pengiriman</p>
                  <p class="text-white">12 Feb 2018</p>
                  <div class="position-relative">
                    <div class="rounded-small-green-right"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="list-data-preorder">
            <h3>Jadwal Pelaksaan Preorder</h3>
            <div class="card-flex">
              <div class="list-preorder orange">
                <div class="position-relative">
                  <div class="title-preorder-list">
                    <div class="rounded-list border-orange"></div>
                    <p class="cl-orange font-weight-bold fs-19 mb-0">
                      Batas Preorder
                    </p>
                    <p class="t-black">12 Feb 2018</p>
                  </div>
                </div>
              </div>
              <div class="list-preorder blue">
                <div class="position-relative">
                  <div class="title-preorder-list first-title-list">
                    <div class="rounded-list border-blue"></div>
                    <p class="cl-blue font-weight-bold fs-19 mb-0">
                      Informasi Harga Final
                    </p>
                    <p class="t-black">12 Feb 2018</p>
                  </div>
                </div>
              </div>
              <div class="list-preorder green">
                <div class="position-relative">
                  <div class="title-preorder-list first-title-list">
                    <div class="rounded-list border-green"></div>
                    <p class="cl-green font-weight-bold fs-19 mb-0">
                      Batas Pelunasan
                    </p>
                    <p class="t-black">12 Feb 2018</p>
                  </div>
                </div>
              </div>
              <div class="list-preorder pink">
                <div class="position-relative">
                  <div class="title-preorder-list first-title-list">
                    <div class="rounded-list border-pink"></div>
                    <p class="cl-pink font-weight-bold fs-19 mb-0">
                      Mulai Pengiriman
                    </p>
                    <p class="t-black">12 Feb 2018</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-12 mt-3">
              <p class="fs-20 font-weight-bold">Pilih Warna Utama</p>
              <div
                v-for="(item, id) in data_color"
                :key="id"
                class="col-md-6 d-inline-block py-2 pointer px-0"
                @click="selected = item.id"
              >
                <div
                  :class="item.class_color"
                  class="circle-color mr-3 position-relative d-inline-block align-middle"
                >
                  <div
                    v-if="selected == item.id"
                    class="position-absolute badge-color rounded-circle text-center"
                  >
                    <b-icon-check2 style="color: #fff;"></b-icon-check2>
                  </div>
                </div>
                <span class="align-middle font-weight-bold">{{
                  item.label
                }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-sm-12 mt-3">
              <p class="fs-20 font-weight-bold">Pilih Warna Primary</p>
              <div
                v-for="(item, id) in data_color2"
                :key="id"
                class="col-md-6 d-inline-block py-2 pointer px-0"
                @click="selected2 = item.id"
              >
                <div
                  :class="item.class_color"
                  class="circle-color mr-3 position-relative d-inline-block align-middle"
                >
                  <div
                    v-if="selected2 == item.id"
                    class="position-absolute badge-color rounded-circle text-center"
                  >
                    <b-icon-check2 style="color: #fff;"></b-icon-check2>
                  </div>
                </div>
                <span class="align-middle font-weight-bold">{{
                  item.label
                }}</span>
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-12">
              <p class="fs-20 font-weight-bold">Pilih Type</p>
            </div>
            <div
              v-for="(item, id) in btn_type"
              :key="id"
              class="col-lg-4 col-md-4 text-center text-white"
              @click="type_selected = id"
            >
              <div class="btn-type" :class="{ 'b-red': id == type_selected }">
                {{ item }}
              </div>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-lg-4 col-md-5 col-sm-12 border-right">
              <div
                @click="selected_add = 1"
                class="col-md-1 d-inline-block col-lg-1 px-0 align-top"
              >
                <div
                  class="circle-radio pointer"
                  :class="selected_add == 1 ? 'b-green' : ''"
                ></div>
              </div>
              <div
                class="col-md-11 d-inline-block col-lg-11 px-0 mb-3 align-top"
              >
                <p
                  class="fs-18 font-weight-bold mb-1 pointer"
                  @click="selected_add = 1"
                >
                  Alamat Pengiriman
                </p>
                <div
                  class="dropdown-select position-relative"
                  :class="selected_add == 1 ? '' : 'disable-select'"
                  @click="
                    selected_add == 1
                      ? (address.active = !address.active)
                      : (address.active = false)
                  "
                >
                  <span>{{ address.label }}</span>
                  <img
                    src="@/assets/img/down_arrow.png"
                    alt=""
                    class="position-absolute"
                  />
                  <div
                    class="wrapper_hanging p-3"
                    :class="{ 'd-block': address.active }"
                  >
                    <p
                      v-for="item in address.options"
                      :key="item.id"
                      @click="selected_dropdown(item, 'address')"
                      class="mb-0 pointer py-2"
                    >
                      {{ item.label }}
                    </p>
                  </div>
                </div>
              </div>

              <div
                @click="selected_add = 2"
                class="col-md-1 d-inline-block col-lg-1 px-0 align-top"
              >
                <div
                  class="circle-radio pointer"
                  :class="selected_add == 2 ? 'b-green' : ''"
                ></div>
              </div>
              <div class="col-md-11 d-inline-block col-lg-11 px-0">
                <span
                  class="fs-18 font-weight-bold mb-1 pointer"
                  @click="selected_add = 2"
                >
                  Ketik Alamat Baru
                </span>
                <input
                  type="text"
                  class="input-data py-1 mb-3 px-3"
                  :class="selected_add == 2 ? '' : 'disable-select'"
                  placeholder="nama"
                />
                <textarea
                  name=""
                  id=""
                  cols="10"
                  rows="10"
                  class="input-data py-1 mb-3 px-3"
                  :class="selected_add == 2 ? '' : 'disable-select'"
                  placeholder="Alamat"
                ></textarea>
                <div
                  class="dropdown-select position-relative mb-3"
                  :class="selected_add == 2 ? '' : 'disable-select'"
                  @click="
                    selected_add == 2
                      ? (provinsi.active = !provinsi.active)
                      : (provinsi.active = false)
                  "
                >
                  <span>{{ provinsi.label }}</span>
                  <img
                    src="@/assets/img/down_arrow.png"
                    alt=""
                    class="position-absolute"
                  />
                  <div
                    class="wrapper_hanging p-3"
                    :class="{ 'd-block': provinsi.active }"
                  >
                    <p
                      v-for="item in provinsi.options"
                      :key="item.id"
                      @click="selected_dropdown(item, 'provinsi')"
                      class="mb-0 pointer py-2"
                    >
                      {{ item.label }}
                    </p>
                  </div>
                </div>
                <div
                  class="dropdown-select position-relative mb-3"
                  :class="selected_add == 2 ? '' : 'disable-select'"
                  @click="
                    selected_add == 2
                      ? (kota.active = !kota.active)
                      : (kota.active = false)
                  "
                >
                  <span>{{ kota.label }}</span>
                  <img
                    src="@/assets/img/down_arrow.png"
                    alt=""
                    class="position-absolute"
                  />
                  <div
                    class="wrapper_hanging p-3"
                    :class="{ 'd-block': kota.active }"
                  >
                    <p
                      v-for="item in kota.options"
                      :key="item.id"
                      @click="selected_dropdown(item, 'kota')"
                    >
                      {{ item.label }}
                    </p>
                  </div>
                </div>
                <div
                  class="dropdown-select position-relative mb-3"
                  :class="selected_add == 2 ? '' : 'disable-select'"
                  @click="
                    selected_add == 2
                      ? (kel.active = !kel.active)
                      : (kel.active = false)
                  "
                >
                  <span>{{ kel.label }}</span>
                  <img
                    src="@/assets/img/down_arrow.png"
                    alt=""
                    class="position-absolute"
                  />
                  <div
                    class="wrapper_hanging p-3"
                    :class="{ 'd-block': kel.active }"
                  >
                    <p
                      v-for="item in kel.options"
                      :key="item.id"
                      @click="selected_dropdown(item, 'kel')"
                    >
                      {{ item.label }}
                    </p>
                  </div>
                </div>
                <div
                  class="dropdown-select position-relative mb-3"
                  :class="selected_add == 2 ? '' : 'disable-select'"
                  @click="
                    selected_add == 2
                      ? (kode.active = !kode.active)
                      : (kode.active = false)
                  "
                >
                  <span>{{ kode.label }}</span>
                  <img
                    src="@/assets/img/down_arrow.png"
                    alt=""
                    class="position-absolute"
                  />
                  <div
                    class="wrapper_hanging p-3"
                    :class="{ 'd-block': kode.active }"
                  >
                    <p
                      v-for="item in kode.options"
                      :key="item.id"
                      @click="selected_dropdown(item, 'kode')"
                    >
                      {{ item.label }}
                    </p>
                  </div>
                </div>
                <input
                  type="checkbox"
                  id="aggrement"
                  class="mr-2 align-middle"
                />
                <label for="aggrement" class="mb-0 align-middle"
                  >Simpan ke daftar alamat</label
                >
              </div>
            </div>
            <div class="col-lg-8 col-md-7 col-sm-12">
              <p class="fs-18 font-weight-bold">Kelengkapan Dokumen</p>
              <b-progress
                variant="danger"
                class="b-s-grey"
                :value="value"
                :max="max"
                show-progress
              ></b-progress>
              <p class="float-right mt-2">{{ value }}%</p>
              <div class="row">
                <div
                  v-for="(item, id) in widget_doc"
                  class="col-lg-3 col-md-3 col-sm-3 col-3 text-center my-4"
                  :key="id"
                >
                  <div
                    @click="$refs.file[id].click()"
                    class="btn_plus b-t-grey rounded-circle m-auto pointer relative"
                  >
                    <img
                      v-if="image[item.id]"
                      :src="image[item.id]"
                      alt=""
                      class="w-100 rounded-circle"
                    />
                    <span v-else>+</span>
                  </div>
                  <input
                    type="file"
                    :id="item.id"
                    @change="onFileChange"
                    ref="file"
                    style="display: none"
                  />
                  <p class="mb-0 mt-1">{{ item.label }}</p>
                  <div
                    v-if="image[item.id]"
                    class="position-absolute text-white fs-12 rounded-circle badge-close pointer"
                    @click="removeImage(item.id)"
                  >
                    X
                  </div>
                </div>

                <div class="col-lg-6 col-md-12 col-12">
                  <textarea
                    name=""
                    id=""
                    cols="10"
                    rows="10"
                    class="input-data py-1 mb-3 px-3"
                    placeholder="Catatan"
                  ></textarea>

                  <input
                    type="checkbox"
                    id="aggrement"
                    class="mr-2 align-middle"
                  />
                  <label for="aggrement" class="mb-0 align-middle"
                    >Proteksi asuransi</label
                  >
                </div>
                <div class="col-lg-6 col-md-12 col-12">
                  <input
                    type="text"
                    class="input-data py-1 mb-3 px-3"
                    placeholder="Nama pemilik di STNK"
                  />
                  <input
                    type="text"
                    class="input-data py-1 mb-3 px-3"
                    placeholder="Nama pemilik di BPKB"
                  />
                  <div
                    class="dropdown-select position-relative mb-3"
                    @click="milik.active = !milik.active"
                  >
                    <span>{{ milik.label }}</span>
                    <img
                      src="@/assets/img/down_arrow.png"
                      alt=""
                      class="position-absolute"
                    />
                    <div
                      class="wrapper_hanging p-3"
                      :class="{ 'd-block': milik.active }"
                    >
                      <p
                        v-for="item in milik.options"
                        :key="item.id"
                        @click="selected_dropdown(item, 'milik')"
                      >
                        {{ item.label }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row bg-white">
          <div class="container py-5">
            <div class="row">
              <div class="col-12 mb-5">
                <p class="font-weight-bold mb-0">Preorder Bill</p>
                <h2>30 Juta</h2>
              </div>
              <div class="col-lg-4 col-md-5 col-sm-12 border-right">
                <p class="font-weight-bold mb-0">Cara Pembayaran</p>
                <div class="col-lg-6 col-md-6 px-0">
                  <div class="w-100 p-1 b-s-grey br-10">
                    <div
                      :class="
                        type_bayar == 'credit' ? 'bg-white text-dark' : ''
                      "
                      class="w-50 d-inline-block br-8 text-center font-weight-bold text-white pointer"
                      @click="type_bayar = 'credit'"
                    >
                      Kredit
                    </div>
                    <div
                      :class="type_bayar == 'cash' ? 'bg-white text-dark' : ''"
                      class="w-50 d-inline-block br-8 text-center font-weight-bold text-white pointer"
                      @click="type_bayar = 'cash'"
                    >
                      Cash
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12 col-sm-12 px-0">
                  <div
                    class="dropdown-select dropdown-grey position-relative mt-3"
                    @click="cicil.active = !cicil.active"
                  >
                    <span>{{ cicil.label }}</span>
                    <img
                      src="@/assets/img/down_arrow.png"
                      alt=""
                      class="position-absolute"
                    />
                    <div
                      class="wrapper_hanging p-3"
                      :class="{ 'd-block': cicil.active }"
                    >
                      <p
                        v-for="item in cicil.options"
                        :key="item.id"
                        @click="selected_dropdown(item, 'cicil')"
                        class="mb-0 pointer py-2"
                      >
                        {{ item.label }}
                      </p>
                    </div>
                  </div>
                  <input
                    type="text"
                    class="input-data mt-3 mb-3 p-2 dropdown-grey "
                    placeholder="Downpayment"
                  />
                </div>
              </div>
              <div class="col-lg-8 col-md-7 col-sm-12">
                <div class="row">
                  <div class="col-lg-6 col-md-12">
                    <p class="font-weight-bold mb-0">Cara Pembayaran</p>
                    <div
                      class="dropdown-select dropdown-grey position-relative"
                      :class="selected_add == 1 ? '' : 'disable-select'"
                      @click="metode.active = !metode.active"
                    >
                      <span>{{ metode.label }}</span>
                      <img
                        src="@/assets/img/down_arrow.png"
                        alt=""
                        class="position-absolute"
                      />
                      <div
                        class="wrapper_hanging p-3"
                        :class="{ 'd-block': metode.active }"
                      >
                        <p
                          v-for="item in metode.options"
                          :key="item.id"
                          @click="selected_dropdown(item, 'metode')"
                          class="mb-0 pointer py-2"
                        >
                          {{ item.label }}
                        </p>
                      </div>
                    </div>
                    <input
                      type="text"
                      class="input-data dropdown-grey p-2 mt-4"
                      placeholder="Nama Pemilik Rekening"
                    />
                    <div class="position-relative">
                      <input
                        class="input-data dropdown-grey p-2 mt-4"
                        placeholder="Nomor Kartu Kredit"
                        v-model="credit_card"
                        @keyup="check_credit($event)"
                        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        type="number"
                        maxlength="16"
                      />
                      <span class="fs-10 position-absolute err_mess">{{
                        error_mes_cc
                      }}</span>
                    </div>
                    <input
                      class="input-data dropdown-grey p-2 mt-4"
                      placeholder="CVV"
                      v-model="cvv"
                      oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                      type="number"
                      maxlength="3"
                    />
                  </div>
                  <div class="col-lg-6 col-md-12 align-self-end">
                    <div class="my-2">
                      <input
                        type="checkbox"
                        id="aggrement"
                        class="mr-2 align-middle"
                      />
                      <label for="aggrement" class="mb-0 align-middle"
                        >Agree to Term</label
                      >
                    </div>
                    <div class="btn-type text-center text-white b-red mb-0">
                      Bayar dan lakukan preorder
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import NavBar from "@/components/partials/NavBar.vue";

export default {
  components: {
    NavBar
  },
  data() {
    return {
      image: {
        ktp: "",
        kk: "",
        doc_1: "",
        doc_2: "",
        doc_lain: "",
        doc_3: "",
        doc_4: "",
        npwp: ""
      },
      cvv: null,
      credit_card: null,
      error_mes_cc: "",
      type_bayar: "cash",
      address: {
        label: "Pilih dari daftar alamat",
        active: false,
        options: [
          { id: 1, label: "Villa tangerang" },
          { id: 2, label: "Jakarta Rumah nenek" },
          { id: 3, label: "Bandung rumah ibu" }
        ]
      },
      provinsi: {
        label: "Provinsi",
        active: false,
        options: [
          { id: 1, label: "Nusa tenggara 1" },
          { id: 2, label: "Nusa tenggara 2" },
          { id: 3, label: "Nusa tenggara 3" }
        ]
      },
      kota: {
        label: "Kota",
        active: false,
        options: [
          { id: 4, label: "Maluku" },
          { id: 5, label: "Papua" },
          { id: 6, label: "Bogor" }
        ]
      },
      kel: {
        label: "Kelurahan",
        active: false,
        options: [
          { id: 7, label: "Sukabumi 1" },
          { id: 8, label: "Sukabumi 2" },
          { id: 9, label: "Sukabumi 3" }
        ]
      },
      kode: {
        label: "Kode Pos",
        active: false,
        options: [
          { id: 10, label: "12345" },
          { id: 11, label: "2345452" },
          { id: 12, label: "4333333" }
        ]
      },
      metode: {
        label: "Metode Pembayaran",
        active: false,
        options: [
          { id: 10, label: "BCA" },
          { id: 11, label: "BNI" },
          { id: 12, label: "OVO" }
        ]
      },
      milik: {
        label: "Jenis kepemilikan",
        active: false,
        options: [
          { id: 10, label: "Data 1" },
          { id: 11, label: "Data 2" },
          { id: 12, label: "Data 3" }
        ]
      },
      cicil: {
        label: "1200X",
        active: false,
        options: [
          { id: 10, label: "1200x" },
          { id: 11, label: "1300x" },
          { id: 12, label: "1400x" }
        ]
      },
      selected_add: 1,
      value: 80,
      max: 100,
      type_selected: null,
      widget_doc: [
        { id: "ktp", label: "KTP" },
        { id: "kk", label: "Kartu Keluarga" },
        { id: "doc_1", label: "Doc 1" },
        { id: "doc_2", label: "Doc 2" },
        { id: "doc_lain", label: "Dokumen lain" },
        { id: "doc_3", label: "Doc 3" },
        { id: "doc_4", label: "Doc 4" },
        { id: "npwp", label: "NPWP" }
      ],
      btn_type: [
        "Standart",
        "Premium + A Specs",
        "Premium ++ A Specs",
        "Premium",
        "Tech + A Specs",
        "Tech ++ A Specs"
      ],
      selected: null,
      selected2: null,
      data_color: [
        {
          id: 1,
          label: "Coklat tua",
          class_color: "b-brown"
        },
        {
          id: 2,
          label: "Merah Berkilau",
          class_color: "b-red"
        },
        {
          id: 3,
          label: "Kuning Silau",
          class_color: "b-yellow"
        },
        {
          id: 4,
          label: "Senja Kelabu",
          class_color: "b-orange"
        },
        {
          id: 5,
          label: "Pinkboy",
          class_color: "b-pink"
        }
      ],
      data_color2: [
        {
          id: 6,
          label: "Coklat tua",
          class_color: "b-brown"
        },
        {
          id: 7,
          label: "Merah Berkilau",
          class_color: "b-red"
        },
        {
          id: 8,
          label: "Kuning Silau",
          class_color: "b-yellow"
        },
        {
          id: 9,
          label: "Senja Kelabu",
          class_color: "b-orange"
        },
        {
          id: 10,
          label: "Pinkboy",
          class_color: "b-pink"
        }
      ]
    };
  },
  methods: {
    selected_dropdown(item, input) {
      if (input == "provinsi") {
        this.provinsi.label = item.label;
      } else if (input == "kota") {
        this.kota.label = item.label;
      } else if (input == "kel") {
        this.kel.label = item.label;
      } else if (input == "kode") {
        this.kode.label = item.label;
      } else if (input == "address") {
        this.address.label = item.label;
      } else if (input == "milik") {
        this.milik.label = item.label;
      } else if (input == "cicil") {
        this.cicil.label = item.label;
      }
    },
    check_credit(e) {
      if (e.target.value.length < 16) {
        this.error_mes_cc = "Nomor kartu kredit harus 16 digit";
      } else {
        this.error_mes_cc = "";
      }
    },
    onFileChange(e) {
      let el_id = e.target.id;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createImage(files[0], el_id);
    },
    createImage(file, id) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = e => {
        vm.image[id] = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeImage(id) {
      this.image[id] = "";
    }
  }
};
</script>
<style scooped>
.list-data-preorder {
  height: 130px;
  margin-bottom: 20px;
}
.card-flex {
  display: flex;
}
.list-preorder {
  height: 10px;
  width: 100%;
  padding: 5px;
}
.orange {
  background: #fa7b58 !important;
  color: #fa7b58;
}
.cl-orange {
  color: #fa7b58;
}
.title-preorder-list {
  text-align: center;
  padding: 20px;
  position: absolute;
  left: -20px;
  width: 150px;
  top: -30px;
}
.rounded-list {
  height: 20px;
  width: 20px;
  margin: auto;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 100px;
  background: #fff;
}
.blue {
  background: #82bfc2 !important;
  color: #82bfc2;
}
.cl-blue {
  color: #82bfc2;
}
.first-title-list {
  left: -80px !important;
  top: -30px !important;
}
.green {
  background: #3f6e82 !important;
  color: #3f6e82;
}
.cl-green {
  color: #3f6e82;
}
.pink {
  background: #e2909e !important;
  color: #e2909e;
}
.cl-pink {
  color: #e2909e;
}
.border-orange {
  border: 5px solid #fa7b58;
}
.border-blue {
  border: 5px solid #82bfc2;
}
.border-green {
  border: 5px solid #3f6e82;
}
.border-pink {
  border: 5px solid #e2909e;
}

/* MOBILE STYLE */
.list-data-preorder-mobile {
  margin-bottom: 30px;
  margin-top: 20px;
  display: none;
}
.border-right-mobile {
  border-right: 1px solid #c1c1c1;
}
.border-left-mobile {
  border-left: 1px solid #c1c1c1;
}
.list-preorder-mobile {
  padding: 15px;
  background: #d5d5d6;
  margin-bottom: 10px;
  border-radius: 12px;
}
.rounded-small-green-left {
  border-radius: 100px;
  height: 25px;
  background: green;
  width: 25px;
  position: absolute;
  right: -44px;
  top: -65px;
  border: 5px solid #f0f0f0;
  z-index: 1;
}
.rounded-small-green-right {
  border-radius: 100px;
  height: 25px;
  background: green;
  width: 25px;
  position: absolute;
  left: -43px;
  top: -75px;
  border: 5px solid #f0f0f0;
  z-index: 1;
}
.mg-bottom120 {
  margin-bottom: 120px !important;
}
.mg-top120 {
  margin-top: 120px !important;
}

.mg-top80 {
  margin-top: 80px !important;
}
.err_mess {
  bottom: -17px;
  left: 0;
  color: red;
}
</style>
